import React from 'react';
import Plx from 'react-plx';

import Logo from 'components/logo';
import {NavItem, Navbar} from 'ui/navbar';

import styles from './index.module.scss';


const HEADER_PARALLAX = [
    {
        start: 0,
        duration: 300,
        properties: [
            {
                property: 'backgroundColor',

                // FIXME: do not hard-code value here
                startValue: 'rgba(47, 37, 108, 0)',
                endValue: 'rgba(47, 37, 108, 0.95)',
            },
            /* {
             *     property: 'height',
             *     startValue: 100,
             *     endValue: 60,
             * } */
        ]
    }
];


function NewHeader() {
    return <Plx parallaxData={HEADER_PARALLAX}
                className={styles.StickyWrapper}
                tagName="header">
        <div className={styles.HeaderContainer} style={{height: `60px`}}>
            <div className={styles.HeaderRow}>
                <div className={styles.logo}>
                    <Logo/>
                </div>
                <div className={styles.nav}>
                    <MainNavbar/>
                </div>
            </div>
        </div>
    </Plx>;
}

export default NewHeader;


function MainNavbar() {
    return <Navbar>
        {/* <NavItem to="/enterprise">Enterprise</NavItem> */}
        {/* <NavItem to="/startups">Startups</NavItem> */}
        <NavItem to="/products">Products</NavItem>
        {/* <NavItem to="/process">Process</NavItem> */}
        <NavItem to="/industries">Industries</NavItem>
        <NavItem to="/technology">Technology</NavItem>
    </Navbar>;
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js